import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import App from './App';
import './theme.scss';
import './index.scss';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <App />
    </Provider>
    </I18nextProvider>
  // </React.StrictMode>
);